export default "__VITE_ASSET__kto2YHNV__"